import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
import Subscription from 'types/subscription'

const resource = 'subscriptions'

export const requests = {
  fetchCurrent: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<Subscription>>(
      mergeURL(resource, 'current'),
    )
  },
}
